import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
  return {
    root: {
      border: `1px solid #e5e6e7`,
      borderRadius: 5,
      '& ul': {
        margin: 0,
        padding: 0,
      },
    },
    titleBox: {
      background: '#eef1f5',
      padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
      boxSizing: 'border-box',
      marginBottom: 0,
    },
    title: {
      color: '#4c6787',
      fontSize: 12,
      fontWeight: 'bold',
    },
    titleArrow: {
      color: '#b9c3ca',
      fontSize: 20,
    },
    listItem: {
      borderTop: `1px solid #e5e6e7`,
      marginTop: 0,
      minHeight: 52,
      '&.odd': {
        background: '#f9f9f9',
      },
      '&.withCopy': {
        paddingInlineEnd: theme.spacing(10),
      },
    },
    listItemText: {
      '& span': {
        display: 'block',
        overflow: 'hidden',
        whiteSpace: 'pre-wrap',
        textOverflow: 'ellipsis',
      },
    },
  };
});